export const CLIENT_VERSION = "2.1.2";
export const PLASMID_FILE_EXT = ".dna";
export const EXPLORE_OVER = "2.7k";
export const CORONAVIRUS_PAGE_ID = "coronavirus_resources";
